<template>
  <div>
    <doughnut-chart
      v-if="!noData && mydata && myType == 'doughnut' && !drawing"
      :chart-data="mydata"
      :options="options"
    />
    <doughnut-chart
      v-if="noData && mydata && myType == 'doughnut' && !drawing"
      :chart-data="nullData"
      :options="nullOptions"
    />
  </div>
</template>

<script>
import IndicatorMixin from '../../mixins/IndicatorMixin.js';
export default {
  mixins: [IndicatorMixin],

  data: () => ({
    mydata: null,
    myType: 'doughnut',
    indicator: 'CDG',
    options: {
      legend: {
        position: 'bottom',
        labels: {
          fontSize: 10,
          usePointStyle: true,
        },
      },
    },
    nullOptions: {
      tooltips: {
        enabled: false,
      },
      legend: {
        position: 'bottom',
        labels: {
          fontSize: 10,
          usePointStyle: true,
        },
      },
    },
    nullData: {
      labels: ['SIN DATOS'],
      datasets: [
        {
          data: [100],
          label: 'Tipos de gastos',
          backgroundColor: ['rgba(212,212,212, 0.9)'],
        },
      ],
    },
  }),

  computed: {
    noData() {
      console.log('MYDATA', this.mydata);
      return (
        this.mydata &&
        this.mydata.labels.length === 1 &&
        this.mydata.labels[0] === 'Otros' &&
        this.mydata.datasets.length === 1 &&
        this.mydata.datasets[0].data.length === 1 &&
        !this.mydata.datasets[0].data[0]
      );
    },
  },
};
</script>
